import WorkerApplicationSigning from 'src/components/AgreementSigningFields/WorkerApplicationSigning';
import { CompanyScheduleActivityPage, PlatformScheduleActivityPage } from 'src/workspaces/ScheduleActivityPage';
import LegacyWorkerDetailAdapter from './workspaces/LegacyWorkerDetailAdapter';
import { Suspense, lazy } from 'react';
import { importWithRetry } from 'src/utils/importWithRetry';
import { Navigate, useLocation } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';
import Login from './components/Login/Login';
import Messenger, { SupportInbox } from 'src/content/applications/Messenger';
import GroupChatMessages from 'src/content/applications/GroupChatMessages';
import InvoiceVersionsData from './content/applications/quote/Invoice/invoiceVersions/invoiceVersionsData';
import GenerateActuals from './content/applications/Jobs/jobsTabs/availabeJobs/jobPositions/actuals/pdf/actuals';
import ForgotPassword from './components/auth/ForgotPassword';
import UpdateDeposit from './content/applications/quote/deposit/deposite';
import { AdminWorkspaceProvider } from './workspaces/AdminWorkspaceProvider';
import AdminSessionEntry from './workspaces/AdminSessionEntry';
import LegacyDashboardBoundary from './workspaces/LegacyDashboardBoundary';
import LegacyWorkersRoute from './workspaces/LegacyWorkersRoute';
import AdminManagementLayout from './workspaces/AdminManagementLayout';
import AdminStandaloneLayout from './layouts/AdminStandaloneLayout';
import { newQuoteWorkspacePath } from './content/applications/quote/quoteWorkspaceRoutes';

// import Attendance from './content/applications/Contractors/contractorDetailTabs/Attendance';
// import ConstructorDetail from './content/applications/Contractors/ConstructorDetail';
const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages

const Overview = Loader(lazy(() => import('src/content/overview')));

// Dashboards

const Crypto = Loader(lazy(() => import('src/content/dashboards/Crypto')));

// Applications

// const Messenger = Loader(
//   lazy(() => import('src/content/applications/Messenger'))
// );
const PositionsUnified = Loader(
  lazy(() => import('src/content/applications/positions/PositionsUnified'))
);

const Positions = Loader(
  lazy(() => import('src/content/applications/positions'))
);
const PositionsCategory = Loader(
  lazy(() => import('src/content/applications/positionsCategory'))
);
const GearCatalog = Loader(
  lazy(() => import('src/content/applications/gearCatalog'))
);

const Dresscodes = Loader(
  lazy(() => import('src/content/applications/dresscodes'))
);

const Announcement = Loader(
  lazy(() => import('src/content/applications/announcement'))
);

const Roles = Loader(
  lazy(() => import('src/content/applications/roles/index'))
);

const Faqs = Loader(lazy(() => import('src/content/applications/faq/index')));
const ActivityLogs = Loader(
  lazy(() => import('src/content/applications/activitylogs/index'))
);

const Settings = Loader(
  lazy(() => import('src/content/applications/settings'))
);
const CompanyProfile = Loader(
  lazy(() => import('src/content/applications/company'))
);

const Venues = Loader(lazy(() => import('src/content/applications/venues')));

const Quote = Loader(lazy(() => import('src/content/applications/quote')));

const LegacyCreateQuoteRedirect = () => {
  const location = useLocation();

  return (
    <Navigate
      to={newQuoteWorkspacePath(location.search)}
      replace
      state={location.state}
    />
  );
};

const UpdateQuote = Loader(
  lazy(() => import('src/content/applications/quote/updateQuote/updateQuote'))
);

const QuoteVersions = Loader(
  lazy(() => import('src/content/applications/quote/quoteVersions/quoteData'))
);
const UpdateInvoice = Loader(
  lazy(
    () =>
      import(
        'src/content/applications/quote/Invoice/updateInvoice/updateInvoice'
      )
  )
);
const Finanicals = Loader(
  lazy(() => import('src/content/applications/financials'))
);

const PayRoll = Loader(
  //@ts-ignore
  lazy(() => import('src/content/applications/payroll'))
);

const Analytics = Loader(
  lazy(() => import('src/content/applications/analytics'))
);

const Operations = Loader(
  lazy(() => import('src/content/applications/operations'))
);

const QuoteTemplate = Loader(
  lazy(() => import('src/content/applications/quote/QuoteTemplate'))
);

const QuoteTemplateSendToClient = Loader(
  lazy(() => import('src/content/applications/quote/quoteTemplateSendToClient'))
);

const InvoiceTemplate = Loader(
  lazy(() => import('src/content/applications/quote/InvoiceTemplate'))
);

const ContractorInvoiceTemplate = Loader(
  lazy(() => import('src/content/applications/quote/contractorInvoiceTemplate'))
);

const InvoiceTemplateSendToClient = Loader(
  lazy(
    () => import('src/content/applications/quote/invoiceTemplateSendToClient')
  )
);

const ActualsTemplateSendToClient = Loader(
  lazy(
    () => import('src/content/applications/quote/actualsTemplateSendToClient')
  )
);

const Jobs = Loader(
  lazy(() => importWithRetry(() => import('src/content/applications/Jobs/jobsTabs/availabeJobs')))
);
const AvailableJobsPosition = Loader(
  lazy(
    () =>
      import('src/content/applications/Jobs/jobsTabs/availabeJobs/jobPositions')
  )
);
const CancelledEvents = Loader(
  lazy(
    () =>
      import(
        'src/content/applications/Jobs/jobsTabs/availabeJobs/cancelledEvents'
      )
  )
);
const BidsOfPosition = Loader(
  lazy(
    () =>
      import(
        'src/content/applications/Jobs/jobsTabs/availabeJobs/jobPositions/allBids/bidsOfPosition'
      )
  )
);

// const ActiveJobs = Loader(
//   lazy(() => import('src/content/applications/Jobs/jobsTabs/activeJobs'))
// );
// const ActiveJobsPosition = Loader(
//   lazy(() => import('src/content/applications/Jobs/jobsTabs/activeJobs/activeJobsTabs'))
// );

// const ActiveJobsPositionAttrndance = Loader(
//   lazy(() => import('src/content/applications/Jobs/jobsTabs/activeJobs/activeJobsTabs/activejobDetail/contractorAttendanceDetail'))
// );

// const ActiveJobsPositionDetail = Loader(
//   lazy(() => import('src/content/applications/Jobs/jobsTabs/activeJobs/activeJobsTabs/activejobDetail/activeJobsPositionsDetail'))
// );
// const CompleteJobs = Loader(
//   lazy(() => import('src/content/applications/Jobs/jobsTabs/completedJobs'))
// );

// const CompleteJobsDetail = Loader(
//   lazy(() => import('src/content/applications/Jobs/jobsTabs/completedJobs/completedJobsDetailTabs'))
// );

// const CompleteJobsPositionDetail = Loader(
//   lazy(() => import('src/content/applications/Jobs/jobsTabs/completedJobs/completedJobsDetailTabs/completedJobsDetail/completedJobsPositionDetail'))
// );

// const CompleteJobsPositionAttendance = Loader(
//   lazy(() => import('src/content/applications/Jobs/jobsTabs/completedJobs/completedJobsDetailTabs/completedJobsDetail/completedJobsPositionDetail/completedJobscontractorAttendance'))
// );

// const CreateJob = Loader(
//   lazy(() => import('src/content/applications/Jobs/jobsTabs/createJobs'))
// );

const Contractors = Loader(
  lazy(() => import('src/content/applications/Contractors/contractors'))
);

const NewApplicants = Loader(
  lazy(
    () =>
      import('src/content/applications/Contractors/contractors/newApplicants')
  )
);

const BlackListUsers = Loader(
  lazy(
    () =>
      import(
        'src/content/applications/Contractors/contractors/blockedUsersTable'
      )
  )
);

const UnlinkShifts = Loader(
  lazy(
    () =>
      import('src/content/applications/Contractors/contractors/UnlinkShifts')
  )
);

const NewApplicantsDetail = Loader(
  lazy(
    () =>
      import(
        'src/content/applications/Contractors/contractors/newApplicantsDetail'
      )
  )
);

const DocumentReviewQueue = Loader(
  lazy(() => import('src/content/applications/Contractors/documentReviewQueue'))
);
const CompanyPendingReviewPage = Loader(
  lazy(() => import('src/workspaces/CompanyPendingReviewPage'))
);
const Attendance = Loader(
  lazy(
    () =>
      import(
        'src/content/applications/Contractors/contractorDetailTabs/AttendanceDetail'
      )
  )
);

// const ContractorsDetail = Loader(
//   lazy(() => import('src/content/applications/Contractors/ConstructorDetail'))
// );

// const AttendenceDetailOfJob = Loader(
//   lazy(() => import('src/content/applications/Contractors/contractorDetailTabs/jobs/attendenceOfJob'))
// );

const UserProfile = Loader(
  lazy(() => import('src/content/applications/Users/profile'))
);

const UserSettings = Loader(
  lazy(() => import('src/content/applications/Users/settings'))
);

const CompanyWorkspaceRoute = Loader(
  lazy(() => import('src/workspaces/CompanyWorkspaceRoute'))
);
const CompanyWorkspaceLanding = Loader(
  lazy(() => import('src/workspaces/CompanyWorkspaceLanding'))
);
const CompanyVenuesPage = Loader(lazy(() => import('src/workspaces/CompanyVenuesPage')));
const CompanyOperationsPage = Loader(
  lazy(() => import('src/workspaces/CompanyOperationsPage'))
);
const CompanyWorkersPage = Loader(
  lazy(() => import('src/workspaces/CompanyWorkersPage'))
);
const CompanyWorkerDetailPage = Loader(
  lazy(() => import('src/workspaces/CompanyWorkerDetailPage'))
);
const CompanyBlockedWorkersPage = Loader(
  lazy(() => import('src/workspaces/CompanyBlockedWorkersPage'))
);
const CompanyAssignmentEventsPage = Loader(
  lazy(() => import('src/workspaces/CompanyAssignmentEventsPage'))
);
const CompanyAssignmentBoardPage = Loader(
  lazy(() => import('src/workspaces/CompanyAssignmentBoardPage'))
);
const CompanyPendingApplicationsPage = Loader(
  lazy(() => import('src/workspaces/CompanyPendingApplicationsPage'))
);
const CompanyAccessCodePage = Loader(
  lazy(() => import('src/workspaces/CompanyAccessCodePage'))
);
const CompanyProfileWorkspacePage = Loader(
  lazy(() => import('src/workspaces/CompanyProfileWorkspacePage'))
);
const CompanyClientProfilePage = Loader(
  lazy(() => import('src/workspaces/CompanyClientProfilePage'))
);
const CompanyInvitationPage = Loader(lazy(() => import('src/workspaces/CompanyInvitationPage')));
const CompanyOnboardingPage = Loader(
  lazy(() => import('src/workspaces/CompanyOnboardingPage'))
);
const PlatformAdminUsersPage = Loader(
  lazy(() => import('src/workspaces/PlatformAdminUsersPage'))
);
const PlatformLegacyContentPage = Loader(
  lazy(() => import('src/workspaces/PlatformLegacyContentPage'))
);
const PlatformWorkspaceRoute = Loader(
  lazy(() => import('src/workspaces/PlatformWorkspaceRoute'))
);
const PlatformDashboardPage = Loader(
  lazy(() => import('src/workspaces/PlatformDashboardPage'))
);
const PlatformCompanyInventoryPage = Loader(
  lazy(() => import('src/workspaces/PlatformCompanyInventoryPage'))
);
const PlatformCompanyLanding = Loader(
  lazy(() => import('src/workspaces/PlatformCompanyLanding'))
);
const PlatformCompanyProfileRoute = Loader(
  lazy(() => import('src/workspaces/PlatformCompanyProfileRoute'))
);
const PlatformCompanyChangeHistoryPage = Loader(
  lazy(() => import('src/workspaces/PlatformCompanyChangeHistoryPage'))
);
const PlatformCompanyApplicationsPage = Loader(
  lazy(() => import('src/workspaces/PlatformCompanyApplicationsPage'))
);
const PlatformWorkforcePage = Loader(
  lazy(() => import('src/workspaces/PlatformWorkforcePage'))
);
const PlatformWorkerDetailPage = Loader(
  lazy(() => import('src/workspaces/PlatformWorkerDetailPage'))
);
const PlatformPositionCatalogPage = Loader(
  lazy(() => import('src/workspaces/PlatformPositionCatalogPage'))
);
const PlatformOnboardingPage = Loader(
  lazy(() => import('src/workspaces/PlatformOnboardingPage'))
);
const PlatformUpdateRequestsPage = Loader(
  lazy(() => import('src/workspaces/PlatformUpdateRequestsPage'))
);

// Components

const Buttons = Loader(
  lazy(() => import('src/content/pages/Components/Buttons'))
);
const Modals = Loader(
  lazy(() => import('src/content/pages/Components/Modals'))
);
const Accordions = Loader(
  lazy(() => import('src/content/pages/Components/Accordions'))
);
const Tabs = Loader(lazy(() => import('src/content/pages/Components/Tabs')));

const Badges = Loader(
  lazy(() => import('src/content/pages/Components/Badges'))
);
const Tooltips = Loader(
  lazy(() => import('src/content/pages/Components/Tooltips'))
);
const Avatars = Loader(
  lazy(() => import('src/content/pages/Components/Avatars'))
);
const Cards = Loader(lazy(() => import('src/content/pages/Components/Cards')));
const Forms = Loader(lazy(() => import('src/content/pages/Components/Forms')));

// Status

const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);
const Status500 = Loader(
  lazy(() => import('src/content/pages/Status/Status500'))
);
const StatusComingSoon = Loader(
  lazy(() => import('src/content/pages/Status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('src/content/pages/Status/Maintenance'))
);

const checkPLS = () => {
  const user = localStorage.getItem('PLS');
  return user ? <AdminSessionEntry /> : <Login />;
};
const routes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: checkPLS()
      },
      {
        path: 'login',
        element: <Login />
      },
      {
        path: 'forgot-password',
        element: <ForgotPassword />
      },
      {
        path: 'company-invitation',
        element: <CompanyInvitationPage />
      },
      {
        path: 'company-application',
        element: <CompanyOnboardingPage />
      },
      {
        path: 'quote/quoteTemplate',
        element: <QuoteTemplate />
      },
      { path: 'worker-application-signing', element: <WorkerApplicationSigning /> },
      {
        path: 'quoteForClient/:id',
        element: <QuoteTemplateSendToClient />
      },
      {
        path: 'quote/invoiceTemplate',
        element: <InvoiceTemplate />
      },
      {
        path: 'invoiceForClient/:id',
        element: <InvoiceTemplateSendToClient />
      },
      {
        path: 'actualsForClient/:id',
        element: <ActualsTemplateSendToClient />
      },
      {
        path: 'quote/contractorInvoice',
        element: <ContractorInvoiceTemplate />
      },
      {
        path: 'status',
        children: [
          {
            path: '',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          },
          {
            path: '500',
            element: <Status500 />
          },
          {
            path: 'maintenance',
            element: <StatusMaintenance />
          },
          {
            path: 'coming-soon',
            element: <StatusComingSoon />
          }
        ]
      },
      {
        path: '*',
        element: <Status404 />
      }
    ]
  },

  {
    path: 'companies/:companyId',
    element: (
      <AdminWorkspaceProvider>
        <CompanyWorkspaceRoute />
      </AdminWorkspaceProvider>
    ),
    children: [
      {
        path: '',
        element: <Navigate to="dashboard" replace />
      },
      {
        path: 'dashboard',
        element: <SidebarLayout />,
        children: [
          {
            index: true,
            element: <CompanyWorkspaceLanding />
          }
        ]
      },
      {
        path: 'compliance',
        element: <SidebarLayout />,
        children: [{ index: true, element: <DocumentReviewQueue /> }]
      },
      {
        path: 'workers',
        element: <SidebarLayout />,
        children: [
          {
            index: true,
            element: <CompanyWorkersPage />
          },
          {
            path: 'pending-review',
            element: <CompanyPendingReviewPage />
          },
          {
            path: 'blocked',
            element: <CompanyBlockedWorkersPage />
          },
          {
            path: ':workerId',
            element: <CompanyWorkerDetailPage />
          }
        ]
      },
      {
        path: 'venues',
        element: <SidebarLayout />,
        children: [{ index: true, element: <CompanyVenuesPage /> }]
      },
      {
        path: 'scheduled-activity',
        element: <SidebarLayout />,
        children: [{ index: true, element: <CompanyScheduleActivityPage /> }]
      },
      {
        path: 'operations',
        element: <SidebarLayout />,
        children: [{ index: true, element: <CompanyOperationsPage /> }]
      },
      {
        path: 'financials',
        element: <SidebarLayout />,
        children: [
          {
            index: true,
            element: <Finanicals />
          }
        ]
      },
      {
        path: 'payroll',
        element: <SidebarLayout />,
        children: [
          {
            index: true,
            element: <PayRoll />
          }
        ]
      },
      {
        path: 'applications',
        element: <SidebarLayout />,
        children: [
          {
            index: true,
            element: <NewApplicants />
          },
          { path: ':membershipId', element: <NewApplicantsDetail /> }
        ]
      },
      {
        path: 'profile',
        element: <SidebarLayout />,
        children: [
          {
            path: 'dashboard',
            element: <CompanyWorkspaceLanding />
          },
          {
            index: true,
            element: <CompanyProfileWorkspacePage />
          },
          {
            path: 'client-profiles/:clientId',
            element: <CompanyClientProfilePage />
          },
          {
            path: 'client-profiles/:clientId/:clientSection',
            element: <CompanyClientProfilePage />
          },
          {
            path: 'data/:resource',
            element: <CompanyProfileWorkspacePage />
          },
          {
            path: 'users-permissions/:adminUserId',
            element: <CompanyProfileWorkspacePage />
          },
          {
            path: ':section',
            element: <CompanyProfileWorkspacePage />
          }
        ]
      },
      {
        element: <AdminStandaloneLayout />,
        children: [
          {
            path: 'access-code',
            element: <CompanyAccessCodePage />
          },
          {
            path: 'assignments',
            element: <CompanyAssignmentEventsPage />
          },
          {
            path: 'assignments/:eventId',
            element: <CompanyAssignmentBoardPage />
          }
        ]
      },
      {
        path: '*',
        element: <Navigate to="/status/404" replace />
      }
    ]
  },

  {
    path: 'platform',
    element: (
      <AdminWorkspaceProvider>
        <PlatformWorkspaceRoute />
      </AdminWorkspaceProvider>
    ),
    children: [
      {
        path: '',
        element: <PlatformDashboardPage />
      },
      { path: 'roles', element: <PlatformAdminUsersPage /> },
      { path: 'scheduled-activity', element: <PlatformScheduleActivityPage /> },
      { path: 'faqs', element: <PlatformLegacyContentPage surface="faqs" /> },
      { path: 'settings', element: <PlatformLegacyContentPage surface="settings" /> },
      { path: 'contactus', element: <Navigate to="/platform/settings" replace /> },
      {
        path: 'company-applications',
        element: <PlatformCompanyApplicationsPage />
      },
      {
        path: 'onboarding',
        element: <PlatformOnboardingPage />
      },
      {
        path: 'support-tickets',
        element: <SupportInbox />
      },
      {
        path: 'update-requests',
        element: <PlatformUpdateRequestsPage />
      },
      {
        path: 'workforce',
        element: <PlatformWorkforcePage />
      },
      {
        path: 'workforce/onboarding',
        element: <PlatformWorkforcePage />
      },
      {
        path: 'workforce/:workerId',
        element: <PlatformWorkerDetailPage />
      },
      {
        path: 'positions',
        element: <PlatformPositionCatalogPage />
      },
      {
        path: 'companies',
        children: [
          {
            path: '',
            element: <PlatformCompanyInventoryPage />
          },
          {
            path: ':companyId',
            element: <PlatformCompanyLanding />
          },
          {
            path: ':companyId/change-history',
            element: <PlatformCompanyChangeHistoryPage />
          },
          {
            path: ':companyId/profile',
            element: <PlatformCompanyProfileRoute />,
            children: [
              {
                element: <SidebarLayout />,
                children: [
                  {
                    path: 'dashboard',
                    element: <CompanyWorkspaceLanding />
                  },
                  {
                    index: true,
                    element: <Navigate to="overview" replace />
                  },
                  {
                    path: 'client-profiles/:clientId',
                    element: <CompanyClientProfilePage />
                  },
                  {
                    path: 'client-profiles/:clientId/:clientSection',
                    element: <CompanyClientProfilePage />
                  },
                  {
                    path: 'data/:resource',
                    element: <CompanyProfileWorkspacePage />
                  },
                  {
                    path: 'users-permissions/:adminUserId',
                    element: <CompanyProfileWorkspacePage />
                  },
                  {
                    path: ':section',
                    element: <CompanyProfileWorkspacePage />
                  }
                ]
              }
            ]
          },
          {
            path: '*',
            element: <Navigate to="/status/404" replace />
          }
        ]
      },
      {
        path: '*',
        element: <Navigate to="/status/404" replace />
      }
    ]
  },

  {
    path: 'dashboards',
    element: (
      <LegacyDashboardBoundary>
        <SidebarLayout />
      </LegacyDashboardBoundary>
    ),
    children: [
      {
        path: '',
        element: <Navigate to="home" replace />
      },
      {
        path: 'home',
        element: <Crypto />
      },
      {
        path: 'contractors',
        element: (
          <LegacyWorkersRoute>
            <Contractors />
          </LegacyWorkersRoute>
        )
      },
      {
        path: 'newApplicants',
        element: <NewApplicants />
      },
      {
        path: 'blacklist',
        element: <BlackListUsers />
      },
      {
        path: 'unlinkShifts',
        element: <UnlinkShifts />
      },
      {
        path: 'newApplicantDetail',
        element: <NewApplicantsDetail />
      },
      {
        path: 'contractorsDetails',
        element: <LegacyWorkerDetailAdapter />
      },
      {
        path: 'documentReview',
        element: <DocumentReviewQueue />
      },
      {
        path: 'contractors/AttendanceDetail',
        element: <Attendance />
      },
      // {
      //   path: 'contractors/detail/jobs/attendence',
      //   element: <AttendenceDetailOfJob />,

      // },

      {
        path: 'jobTracker',
        element: <Jobs />
      },
      {
        path: 'jobTracker/positions/:id',
        element: <AvailableJobsPosition />
      },
      {
        path: 'jobTracker/positions/:id/bids',
        element: <AvailableJobsPosition />
      },
      {
        path: 'jobTracker/generate-actuals/:id',
        element: <GenerateActuals />
      },
      {
        path: 'jobTracker/deposit/:id',
        element: <UpdateDeposit />
      },
      {
        path: 'jobTracker/positions/bids/:id',
        element: <BidsOfPosition />
      },
      {
        path: 'jobTracker/positions/bids',
        element: <BidsOfPosition />
      },
      {
        path: 'jobTracker/cancelledEvents',
        element: <CancelledEvents />
      },

      {
        path: 'messenger',
        element: <Messenger />
      },
      {
        // Chat 4.6 (#423): admin support inbox. Mounted as a peer route so
        // the inbox table can use the full viewport without the
        // sidebar/pane split from /dashboards/messenger.
        path: 'messenger/support',
        element: <SupportInbox />
      },

      {
        path: 'group-chat-messages',
        element: <GroupChatMessages />
      },

      {
        path: 'positions',
        element: <PositionsUnified />
      },
      {
        path: 'positions-category',
        element: <PositionsCategory />
      },
      {
        path: 'gear-catalog',
        element: <GearCatalog />
      },
      // {
      //   path: 'announcement',
      //   element: <Announcement />
      // },
      {
        path: 'roles',
        element: <Roles />
      },
      {
        path: 'faqs',
        element: <Faqs />
      },
      {
        path: 'activites',
        element: <ActivityLogs />
      },
      {
        path: 'contactus',
        element: <Navigate to="/dashboards/settings" replace />
      },
      {
        path: 'settings',
        element: <Settings />
      },
      {
        path: 'company-profile',
        element: <CompanyProfile />
      },
      {
        path: 'venues',
        element: <Venues />
      },
      {
        path: 'quote/createQuote',
        element: <LegacyCreateQuoteRedirect />
      },
      {
        path: 'quote/updateQuote',
        element: <UpdateQuote />
      },
      {
        path: 'quote/versions',
        element: <QuoteVersions />
      },
      {
        path: 'quote/updateInvoice',
        element: <UpdateInvoice />
      },
      {
        path: 'invoice/versions',
        element: <InvoiceVersionsData />
      },
      {
        path: 'quote',
        element: <Quote />
      },
      {
        path: 'financials',
        element: <Finanicals />
      },
      {
        path: 'payroll',
        element: <PayRoll />
      },
      {
        path: 'analytics',
        element: <Analytics />
      },
      {
        path: 'operations',
        element: <Operations />
      },
      {
        path: 'tickets',
        element: <Navigate to="/dashboards/messenger/support" replace />
      },
      {
        path: 'marketplace',
        element: <Analytics />
      }
      // {
      //   path: 'quote/quoteTemplte',
      //   element: <QuoteTemplate />
      // }
    ]
  },
  {
    path: 'management',
    element: <AdminManagementLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="transactions" replace />
      },
      // {
      //   path: 'transactions',
      //   element: <Transactions />
      // },
      {
        path: 'profile',
        children: [
          {
            path: '',
            element: <Navigate to="details" replace />
          },
          {
            path: 'details',
            element: <UserProfile />
          },
          {
            path: 'settings',
            element: <UserSettings />
          }
        ]
      }
    ]
  },
  {
    path: '/components',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="buttons" replace />
      },
      {
        path: 'buttons',
        element: <Buttons />
      },
      {
        path: 'modals',
        element: <Modals />
      },
      {
        path: 'accordions',
        element: <Accordions />
      },
      {
        path: 'tabs',
        element: <Tabs />
      },
      {
        path: 'badges',
        element: <Badges />
      },
      {
        path: 'tooltips',
        element: <Tooltips />
      },
      {
        path: 'avatars',
        element: <Avatars />
      },
      {
        path: 'cards',
        element: <Cards />
      },
      {
        path: 'forms',
        element: <Forms />
      }
    ]
  }
];

export default routes;
